<template>
  <vx-card id="purchase-detail">
    <template v-if="purchase">
      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-1/2 text-left">
          <h1>TRANSACTION DETAIL</h1>
          <div class="invoice__invoice-detail mt-6">
            <h6>TRANSACTION ID.</h6>
            <p>{{ purchase.id }}</p>

            <h6 class="mt-4">TRANSACTION DATE</h6>
            <p>{{ dayjs(purchase.transactionDate).format('DD/MM/YYYY hh:mm:ss') }}</p>

            <h6 class="mt-4">Owner</h6>
            <router-link :to="`/user/${purchase.wallet.ownerId}`"> {{ purchase.wallet.username }} </router-link>

            <h6 class="mt-4">Remark</h6>
            <p>{{ purchase.remark }}</p>
          </div>
        </div>
      </div>

      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-full">
          <vs-table data="[]">
            <template slot="thead">
              <vs-th class="pointer-events-none">PRODUCT</vs-th>
              <vs-th class="pointer-events-none">TYPE</vs-th>
              <vs-th class="pointer-events-none">STATUS</vs-th>
              <vs-th class="pointer-events-none">AMOUNT</vs-th>
            </template>
            <tbody>
              <vs-tr>
                <vs-td>{{ purchase.description }}</vs-td>
                <vs-td>{{ purchase.type }}</vs-td>
                <vs-td>{{ purchase.status }}</vs-td>
                <vs-td>{{ purchase.wallet.balance.currency }} {{ purchase.amount }}</vs-td>
              </vs-tr>
            </tbody>
          </vs-table>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      purchase: ({ purchase }) => purchase.purchase,
      getPurchaseState: ({ purchase }) => purchase.apiState.getPurchase,
    }),
    transactionId() {
      return this.$route.params.id || undefined;
    },
    dayjs() {
      return dayjs;
    },
  },
  methods: {
    ...mapActions({
      getPurchase: 'purchase/getPurchase',
    }),
  },
  async mounted() {
    await this.getPurchase(this.transactionId);
  },
};
</script>

<style lang="scss"></style>
